import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import AirdropTxViewLayer from "../../components/AirdropCampagin/AirdropTxViewLayer";

const AirdropTxViewPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Airdrop Transaction Details" />

        <AirdropTxViewLayer />
      </MasterLayout>
    </>
  );
};

export default AirdropTxViewPage;
